<template>
<section  v-if="downloadedBoxes && downloadedBoxes.length > 0">
  <h3 class="title is-spaced">Les meves descàrregues</h3>
  <!-- <h3 class="subtitle">Les meves caixes descarregades</h3> -->
  <div class="columns is-multiline is-desktop">
      <div class="column is-one-third" v-for="box in downloadedBoxes" v-bind:key="box.id">
        <BoxItemDetail :box="box"></BoxItemDetail>
      </div>
    </div>
</section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");
import BoxItemDetail from '@/components/BoxItemDetail'

export default {
  components: {
    BoxItemDetail
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "downloadedBoxes"])
  },
  mounted () {    
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MyDownloads.vue